var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-wrap"},[_c('header-component'),_c('router-view'),_c('pwa-install',{attrs:{"install-description":"For a better experience, we highly encourage you to install the Enduro Biking app. Please follow the instructions below.","manifest-url":"/pwa/manifest.json"}})],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }